export const getLeadName = contact => contact?.buyer || contact?.webhookFormData?.name || '';

export const getLeadEmail = contact => contact?.buyerEmail || contact?.webhookFormData?.email || '';

export const getLeadPhone = contact => contact?.cellPhone || contact?.webhookFormData?.phone || '';

export const parseDesiredMonthlyPayment = value => {
  if (value === null || value === undefined || value === '') return null;
  const num = parseFloat(String(value).replace(/[^0-9.]/g, ''));
  return Number.isFinite(num) ? num : null;
};

export const formatPhoneForTel = phone => (phone ? String(phone).replace(/\D/g, '') : '');

export const getTimelineBadgeVariant = timeline => {
  const t = (timeline || '').toLowerCase();
  if (t.includes('asap')) return 'danger';
  if (t.includes('1-3') || t.includes('1 to 3')) return 'warning';
  if (t.includes('browsing')) return 'secondary';
  return 'info';
};

/** Contract _id from populated exportedContract or raw ObjectId string. */
export const getExportedContractId = exportedContract => {
  if (!exportedContract) return null;
  if (typeof exportedContract === 'string') return exportedContract;
  return exportedContract._id || null;
};

/** Human-readable contract label for Exported To column (buyer name on contract). */
export const getExportedContractDisplayName = exportedContract => {
  const id = getExportedContractId(exportedContract);
  if (!id) return null;
  if (typeof exportedContract === 'object' && exportedContract !== null) {
    const name = exportedContract.buyer?.trim();
    if (name) return name;
  }
  return 'View contract';
};
